/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reaction_AddedInputs */

const en_reaction_added = /** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaction added`)
};

const es_reaction_added = /** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reacción añadida`)
};

const fr_reaction_added = /** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réaction ajoutée`)
};

const de_reaction_added = /** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktion hinzugefügt`)
};

const id_reaction_added = /** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaksi ditambahkan`)
};

/** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */
const ja_reaction_added = en_reaction_added;

/** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */
const zh_reaction_added = en_reaction_added;

/** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */
const ar_reaction_added = en_reaction_added;

/** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */
const it_reaction_added = en_reaction_added;

/** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */
const ru_reaction_added = en_reaction_added;

/** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */
const pt_reaction_added = en_reaction_added;

/** @type {(inputs: Reaction_AddedInputs) => LocalizedString} */
const ko_reaction_added = en_reaction_added;

/**
* | output |
* | --- |
* | "Reaction added" |
*
* @param {Reaction_AddedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reaction_added = /** @type {((inputs?: Reaction_AddedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reaction_AddedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reaction_added(inputs)
	if (locale === "es") return es_reaction_added(inputs)
	if (locale === "fr") return fr_reaction_added(inputs)
	if (locale === "de") return de_reaction_added(inputs)
	if (locale === "ja") return ja_reaction_added(inputs)
	if (locale === "zh") return zh_reaction_added(inputs)
	if (locale === "ar") return ar_reaction_added(inputs)
	if (locale === "id") return id_reaction_added(inputs)
	if (locale === "it") return it_reaction_added(inputs)
	if (locale === "ru") return ru_reaction_added(inputs)
	if (locale === "pt") return pt_reaction_added(inputs)
	return ko_reaction_added(inputs)
});